import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    if (this.hasModalTarget) {
      this.modal = new Modal(this.modalTarget)

      // Listen for turbo stream events to close modal when instance is deleted
      document.addEventListener('turbo:before-stream-render', this.handleStreamRender.bind(this))
    } else {
      console.error("Modal target not found!")
    }
  }
  
  disconnect() {
    document.removeEventListener('turbo:before-stream-render', this.handleStreamRender.bind(this))
  }
  
  handleStreamRender(event) {
    const { target, action } = event.detail.newStream
    // If removing an instance and modal is open, close it
    if (action === 'remove' && target && target.startsWith('instance_') && this.modal) {
      this.modal.hide()
      // Clean up backdrop
      setTimeout(() => {
        document.querySelectorAll('.modal-backdrop').forEach(backdrop => backdrop.remove())
        document.body.classList.remove('modal-open')
        document.body.style.removeProperty('overflow')
        document.body.style.removeProperty('padding-right')
      }, 300)
    }
  }

  show(event) {
    event.preventDefault()
    const instanceId = event.currentTarget.dataset.instanceId

    if (!this.modal) {
      console.error("Modal object not available.")
      return
    }

    const modalContent = this.modalTarget.querySelector('.modal-content')

    // Set loading state immediately
    modalContent.innerHTML = `
      <div class="modal-header">
        <h5 class="modal-title">Loading...</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>`

    this.modal.show()

    fetch(`/instances/${instanceId}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text()
      })
      .then(html => {
        modalContent.innerHTML = html
      })
      .catch(error => {
        console.error('Error fetching instance details:', error)
        modalContent.innerHTML = `
          <div class="modal-header">
            <h5 class="modal-title">Error</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>Could not load instance details.</p>
          </div>`
      })
  }
}
